module.exports = __webpack_public_path__ + "static/media/1023495.e170dbba.png";